import { School as StudentIcon } from '@mui/icons-material';
import { createTheme } from '@mui/material';
import React from 'react';

interface UserRole {
  id: number;
  title: string;
  icon: React.ReactNode;
  isPrimary: boolean;
}

export const userRoles: UserRole[] = [
  {
    id: 2,
    title: 'LOGAR COM @ESCOLA',
    icon: <StudentIcon fontSize="medium" />,
    isPrimary: true,
  },
];

export const primaryColor = '#2563EB';
export const secondaryColor = '#10B981';

export const theme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
      light: '#60A5FA',
      dark: '#1E40AF',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: secondaryColor,
      light: '#34D399',
      dark: '#059669',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F9FAFB',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1F2937',
      secondary: '#6B7280',
    },
  },
  typography: {
    h5: {
      fontWeight: 600,
      letterSpacing: '0.5px',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
    subtitle2: {
      letterSpacing: '1.2px',
      fontWeight: 600,
    },
    body1: {
      lineHeight: 1.6,
    },
    body2: {
      lineHeight: 1.6,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: 'none',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.06)',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(0, 0, 0, 0.06)',
        },
      },
    },
  },
});
